export enum FsLightboxTypeEnum {
    IMAGE = 'image',
    VIDEO = 'video',
    YOUTUBE = 'youtube',
}
